import l10n from './l10n';

import TranslationManager from '../../shared/service/translation-manager';

// -------
// Private
// -------

const tm = (() => {
	if(!window.ifabTM) {
		window.ifabTM = new TranslationManager();

		window.ifabTM.addLanguages(l10n);
	}

	return window.ifabTM;
})();

// ------
// Public
// ------

// Export
export default {
	icons: {
		close      : '<span aria-hidden="true" class="far fa-times" data-icon></span>',
		next       : '<span aria-hidden="true" class="far fa-chevron-right" data-icon></span>',
		prev       : '<span aria-hidden="true" class="far fa-chevron-left" data-icon></span>',
		// ...
		bell       : '<span aria-hidden="true" class="icon fa-regular fa-bell" data-icon></span>',
		bus        : '<span aria-hidden="true" class="icon fa-regular fa-bus" data-icon></span>',
		book       : '<span aria-hidden="true" class="icon fa-regular fa-book" data-icon></span>',
		coffeeHot  : '<span aria-hidden="true" class="icon fa-regular fa-mug-hot" data-icon></span>',
		lightBulb  : '<span aria-hidden="true" class="icon fa-regular fa-lightbulb" data-icon></span>',
		moon       : '<span aria-hidden="true" class="icon fa-regular fa-moon" data-icon></span>',
		personFairy: '<span aria-hidden="true" class="icon fa-regular fa-person-fairy" data-icon></span>'
	},
	backgroundPatterns: [
		'-stripes-d',
		'-stripes-h',
		'-cross',
		'-zigzag',
		'-zigzag-h',
		'-waves',
		'-waves-gently'
	],
	l10n: tm
};
